import React from 'react'
import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'

const StandaloneLayout: React.FC<BoxProps> = ({ children, ...props }) => (
  <Box id="app-content" height="100%" minHeight="0" width="100%" overflowY="auto" overflowX="hidden" {...props}>
    {children}
  </Box>
)

export default StandaloneLayout
